import { motion } from 'framer-motion';

interface FooterProps {
  className?: string;
}

const Footer = ({ className = '' }: FooterProps) => {
  return (
    <motion.div 
      className={`text-center ${className}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.6 }}
    >
      <p className="text-[#8a7266] text-sm flex items-center justify-center gap-1">
        Need help? 
        <motion.a 
          href="#" 
          className="text-[#ff8c42] hover:underline flex items-center font-medium relative group"
          whileHover={{ y: -1 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          Contact support
          <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#ff8c42] to-[#694e42] group-hover:w-full transition-all duration-300"></span>
          <motion.svg 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg" 
            className="ml-1"
            animate={{ x: [0, 3, 0] }}
            transition={{ 
              duration: 1.5, 
              repeat: Infinity,
              repeatType: "reverse"
            }}
          >
            <path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 5L19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </motion.svg>
        </motion.a>
      </p>
    </motion.div>
  );
};

export default Footer; 